<template>
    <div class="post-listado">
        <table class="table table-bordered">
            <thead class="thead-inverse">
                <tr>
                    <th>Fecha</th>
                    <th>Titulo</th>
                    <th>Descripcion Corta</th>
                </tr>
            </thead>
            <tbody>
                <tr @click="abrir(post.key)" v-for="post in posts">
                    <td>{{ post.fecha }}</td>
                    <td>{{ post.titulo }}</td>
                    <td>{{ post.descripcionCorta }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import fireApp from '../services/fireConfig.js'

import { getAll } from '../services/blog/blog.service.js'

export default {
    name: 'post-listado',

    data () {
        return {
            posts: null
        }
    },

    created () {
        let cmp = this;

        getAll(function(posts) {
            cmp.posts = posts;
        });

    },

    methods: {
        abrir(id) {
            this.$router.push({ name: 'postEdit', params: {id: id}});
        }
    }
}
</script>

<style scoped>
    tr {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// Post-Listado.vue?11495a70